var checkIsOpenTooltip = function checkIsOpenTooltip() {
  var tooltipPortalElement = document.getElementById("___tooltip");
  if (tooltipPortalElement && tooltipPortalElement.innerHTML.trim() !== "") {
    return true;
  }
  return false;
};
export default checkIsOpenTooltip;